export default __webpack_public_path__ + "static/media/rtg-3.723aad69.svg";